import { RootState } from "../redux-types";
import { useSelector, TypedUseSelectorHook } from 'react-redux'


export const rehydratedSelector = (store: any) => {
  if (store._persist) {
    return store._persist.rehydrated;
  }
  return false;
};

export const appSelector: TypedUseSelectorHook<RootState> = useSelector
